// 注册全局组件
export default {
  install(Vue, options) {
    // 审批状态
    Vue.prototype.switchApproveStatus = function(status) {
      if (status == "1") {
        return "已通过";
      } else if (status == "0") {
        return "待审批";
      } else {
        return "未通过";
      }
    };
    // 将时间的long转换为YYYY-MM-dd HH:mm:ss
    Vue.prototype.timeStamp = function(dateStamp) {
      if (dateStamp) {
        let date = new Date(dateStamp);
        let Y = date.getFullYear() + "-";
        let M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        let D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        let H =
          (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
          ":";
        let Mi =
          (date.getMinutes() < 10
            ? "0" + date.getMinutes()
            : date.getMinutes()) + ":";
        let S =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        let tempDate = Y + M + D + H + Mi + S;
        return tempDate;
      }
      return "";
    };
    // tag换颜色
    Vue.prototype.getTagColor = function(flowStatus) {
      if (flowStatus == 0) {
        return "primary";
      } else if (flowStatus == 1) {
        return "success";
      } else if (flowStatus == 2) {
        return "warning";
      }
    };
  },
};
